// Klocki pakietu z Karta.tsx (osobny plik - limit 300 linii; import dalej przez ./Karta): kroki kreatora,
// stronicowanie, belka akcji. Oś czasu - w Karta.tsx.
import type { ReactNode } from "react";
import { t } from "../i18n/t";
import { cx } from "./klasy";
import { IkonaWLewo, IkonaWPrawo } from "./ikony";
import "../styles/wspolne.css";

/* ---------- Kroki kreatora ---------- */
export function KrokiKreatora({ kroki, biezacy }: { kroki: ReadonlyArray<string>; biezacy: number }) {
  return (
    <ol className="iot-kroki" aria-label={t("Krok {nr} z {razem}", { nr: biezacy + 1, razem: kroki.length })}>
      {kroki.map((k, i) => (
        <li key={k} className={cx("iot-kroki__krok", i < biezacy && "is-done", i === biezacy && "is-current")} aria-current={i === biezacy ? "step" : undefined}>{k}</li>
      ))}
    </ol>
  );
}

/* ---------- Stronicowanie ---------- */
export interface StronicowanieProps {
  strona: number;
  liczbaStron: number;
  onZmien: (strona: number) => void;
}

function numeryStron(strona: number, liczba: number): Array<number | "..."> {
  if (liczba <= 7) return Array.from({ length: liczba }, (_, i) => i + 1);
  const zestaw = new Set([1, 2, strona - 1, strona, strona + 1, liczba - 1, liczba].filter((n) => n >= 1 && n <= liczba));
  const posortowane = [...zestaw].sort((a, b) => a - b);
  const wynik: Array<number | "..."> = [];
  posortowane.forEach((n, i) => {
    const poprzedni = posortowane[i - 1];
    if (poprzedni !== undefined && n - poprzedni > 1) wynik.push("...");
    wynik.push(n);
  });
  return wynik;
}

export function Stronicowanie({ strona, liczbaStron, onZmien }: StronicowanieProps) {
  if (liczbaStron <= 1) return null;
  return (
    <nav className="iot-stronicowanie" aria-label={t("Strony")}>
      <button type="button" className="iot-stronicowanie__strona" aria-label={t("Poprzednia strona")} disabled={strona <= 1} onClick={() => onZmien(strona - 1)}><IkonaWLewo /></button>
      {numeryStron(strona, liczbaStron).map((n, i) =>
        n === "..." ? <span key={`p${i}`} className="iot-stronicowanie__strona" aria-hidden="true">…</span> : (
          <button key={n} type="button" className="iot-stronicowanie__strona" aria-current={n === strona ? "page" : undefined} onClick={() => onZmien(n)}>{n}</button>
        ),
      )}
      <button type="button" className="iot-stronicowanie__strona" aria-label={t("Następna strona")} disabled={strona >= liczbaStron} onClick={() => onZmien(strona + 1)}><IkonaWPrawo /></button>
    </nav>
  );
}

/* ---------- Belka akcji (przyklejona u dołu na telefonie) ---------- */
export function BelkaAkcji({ children }: { children: ReactNode }) {
  return <div className="iot-belka-akcji">{children}</div>;
}
